/* @flow */

export const CACHED_LANG_KEY = 'RES.i18nCachedLang';
export const CACHED_MESSAGES_KEY = 'RES.i18nCachedMessages';
export const CACHED_MESSAGES_TOKEN_KEY = 'RES.i18nCachedMessagesToken';



// WEBPACK FOOTER //
// ./lib/constants/localStorage.js